export default {
    type: 'container',
    name: 'Container',
    osOnly: false,
    components: {
        root: {
            name: 'ModuleContainer',
            loader: () => import('./ModuleContainer')
        }
    }
};
